import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, flatMap, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { SsoAuthService } from 'src/app/ecan/sso-auth.service';

@Injectable()
export class TokenErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private ssoAuthService: SsoAuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        tap(() => this.authService.authError = ''),
        catchError((error, caught) => {
          if (error instanceof HttpErrorResponse) {
            return from(this.authService.tryImplicitOrRequireLogin())
              .pipe(flatMap(() => next.handle(this.bindLatestToken(request))));
          } else {
            return throwError(error);
          }
        })
      );
  }

  /**
   * Update the original request with the newly-retrieved access token
   */
  bindLatestToken(request: HttpRequest<any>): HttpRequest<any> {
    const accessToken = this.ssoAuthService.getToken();
    const newRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return newRequest;
  }
}
